var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.template.name
      ? _c("div", { staticClass: "questionnaireGroupHeader" }, [
          _c("span", { staticClass: "questionnaireGroupHeaderText" }, [
            _vm._v(_vm._s(_vm.template.name)),
          ]),
        ])
      : _vm._e(),
    _c(
      "div",
      { staticClass: "questionnaireGroupCells" },
      [
        _vm._l(_vm.model.cells, function (question) {
          return _c("questionnaire-view-question", {
            key: question.id,
            attrs: {
              model: question,
              template: _vm.getTemplate(question.id),
              response: _vm.response,
            },
          })
        }),
        _c("div", { staticClass: "questionnaireGroupCellsLastItem" }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }